import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Baseurl, Imageurl } from "../../config/BaseUrl";
import axios from "axios";
import moment from "moment-timezone";
import { Modal, Button } from "antd";
import { Switch } from "antd";

const ReadyReport = () => {
  const { loginData } = useSelector((store) => store.auth);
  const { readyReport, assignedAgent } = useSelector((store) => store.cases);

  const [search, setSearch] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [filteredCase, setFilteredCase] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [urlPath, setUrlPath] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCase, setSelectedCase] = useState("");
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [selectedDateCase, setSelectedDateCase] = useState("");
  const [alterDate, setAlterDate] = useState(new Date());
  const [alterUpdateDate, setAlterUpdateDate] = useState(new Date());
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [PaymentCase, setPaymentCase] = useState("");
  const [statusOfPayment, setStatusOfPayment] = useState(null);
  const [remarkOfPayment, setRemarkOfPayment] = useState("");

  // Infinite scroll states
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const showPaymentModal = (data) => {
    setPaymentCase(data);
    setStatusOfPayment(data?.paymentStatus);
    setRemarkOfPayment(data?.paymentRemark);
    setPaymentModalOpen(true);
  };

  const handlePaymentStatus = () => {
    setStatusOfPayment(!statusOfPayment);
  };

  const handlePaymentCancel = () => {
    setPaymentModalOpen(false);
  };

  const handleUpdatePayment = async (e) => {
    const updateCase = {
      ...PaymentCase,
      paymentStatus: statusOfPayment,
      paymentRemark: remarkOfPayment,
    };
    const config = {
      Headers: { "Content-Type": "application/json" },
    };
    const url = `${Baseurl}/api/v1/cases/updatecase/${PaymentCase._id}`;
    const resp = await axios.put(url, updateCase, config);
    if (resp.data.success) {
      setPaymentCase("");
      setStatusOfPayment(null);
      setPaymentModalOpen(false);
      alert("Payment Status updated successfully");
      window.location.reload();
    }
  };

  const showDateModal = (data) => {
    setIsDateModalOpen(true);
    setSelectedDateCase(data);
  };

  const handleDateOk = () => {
    setIsDateModalOpen(false);
  };

  const handleDateCancel = () => {
    setIsDateModalOpen(false);
  };

  const updateDateClick = async (e) => {
    const selectedDate = new Date(alterDate);
    const selectedUpdateDate = new Date(alterUpdateDate);
    const currentDate = new Date();
    if (selectedDate < currentDate && selectedUpdateDate < currentDate) {
      const formData = {
        createdAt: alterDate,
        submittedAt: alterUpdateDate,
      };
      const config = {
        Headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/cases/updatecase/${selectedDateCase._id}`;
      const resp = await axios.put(url, formData, config);
      if (resp.data.success) {
        setIsDateModalOpen(false);
        setSelectedDateCase("");
        alert("Date updated successfully");
      }
    } else {
      alert("Please select a valid date");
      setIsDateModalOpen(false);
      setSelectedDateCase("");
    }
  };

  const onChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const currentDate = new Date();
    if (selectedDate > currentDate) {
      alert("Selected date is in the future. Please select a valid date.");
    } else {
      if (selectedDate) {
        const formattedDate = selectedDate.toISOString();
        setAlterDate(formattedDate);
      }
    }
  };

  const onUpdateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const currentDate = new Date();
    if (selectedDate > currentDate) {
      alert("Selected date is in the future. Please select a valid date.");
    } else {
      if (selectedDate) {
        const formattedDate = selectedDate.toISOString();
        setAlterUpdateDate(formattedDate);
      }
    }
  };

  const showModal = (data) => {
    setSelectedCase(data);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const updateClick = async () => {
    const url = `${Baseurl}/api/v1/cases/deletecase/${selectedCase._id}`;
    const resp = await axios.delete(url);
    if (resp.data.success) {
      setIsModalOpen(false);
      setSelectedCase("");
      window.location.reload();
    }
  };

  // Fetch reports with pagination
  const fetchMoreData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${Baseurl}/api/v1/cases/readyreports?page=${page + 1}&limit=100`
      );
      console.log(response, "response");

      const newReports = response.data.cases;
      console.log(newReports, "newReports");

      if (newReports.length === 0) {
        setHasMore(false);
        return;
      }

      if (loginData?.role === "businessAssociate") {
        const permittedStates = loginData.permittedState.map((s) =>
          s.toLowerCase()
        );

        const filtered = newReports.filter(
          (indCase) =>
            permittedStates.includes(indCase.state.toLowerCase()) &&
            indCase.businessAssociate?.id === loginData._id
        );

        setFilterData((prev) => [...prev, ...filtered]);
        setFilteredCase((prev) => [...prev, ...filtered]);
      } else {
        setFilterData((prev) => [...prev, ...newReports]);
        setFilteredCase((prev) => [...prev, ...newReports]);
      }
      setPage((prev) => prev + 1);
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  }, [page, loginData]);

  // Initial data load
  const loadInitialData = async () => {
    try {
      const response = await axios.get(
        `${Baseurl}/api/v1/cases/readyreports?page=1&limit=100`
      );
      const initialReports = response.data.cases;
      if (loginData?.role === "businessAssociate") {
        console.log(initialReports, "initialReports");

        const permittedStates = loginData.permittedState.map((s) =>
          s.toLowerCase()
        );

        const filtered = initialReports.filter(
          (indCase) =>
            permittedStates.includes(indCase.state?.toLowerCase()) &&
            indCase.businessAssociate?.id === loginData._id
        );
        setFilterData(filtered);
        setFilteredCase(filtered);
      } else {
        setFilterData(initialReports);
        setFilteredCase(initialReports);
      }

      if (initialReports.length < 10) {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error loading initial data:", error);
    }
  };
  useEffect(() => {
    loadInitialData();
  }, [loginData]);

  const handleSearch = (e) => {
    if (search.trim() !== "") {
      const loadInitialData = async () => {
        try {
          const response = await axios.get(
            `${Baseurl}/api/v1/cases/readyreports?page=1&limit=20&searchText=${search}`
          );
          console.log(response.data, "response");

          const initialReports = response.data.cases;

          if (loginData?.role === "businessAssociate") {
            const permittedStates = loginData.permittedState.map((s) =>
              s.toLowerCase()
            );
            const filtered = initialReports.filter(
              (indCase) =>
                indCase.state &&
                permittedStates.includes(indCase.state.toLowerCase()) &&
                indCase.businessAssociate?.id === loginData._id
            );
            setFilterData(filtered);
          } else {
            setFilterData(initialReports);
          }

          if (initialReports.length < 10) {
            setHasMore(false);
          }
        } catch (error) {
          console.error("Error loading initial data:", error);
        }
      };

      loadInitialData();
    } else {
      alert("enter vehicle no.");
    }
  };
  const handleReset = async () => {
    window.location.reload();
  };

  const handleUpdateReport = async (individualCase) => {
    const formData = {
      status: 4,
      statusText: "Case Submitted",
    };
    const config = {
      Headers: { "Content-Type": "application/json" },
    };
    const url = `${Baseurl}/api/v1/cases/updatecase/${individualCase._id}`;
    const resp = await axios.put(url, formData, config);
    if (resp.data.success) {
      navigate(`/admin/editreport/${individualCase._id}`);
    }
  };
  async function generateJWTToken() {
    const url = "https://sslapi.trucksups.in/JwtAuth/api/Auth/GenerateJWTtoken";
    const headers = {
      "x-api-key": "IXebdb3P3qfMseQtgZxD7qxHdkUr3Ylq",
      "Content-Type": "application/json",
    };
    const body = JSON.stringify({
      username: "TRUCKSHUBBS002",
      password: "TrucksHub@336136",
      apiSecreteKey: "147A1FFE-F053-48DA-8764-4A3415C05144",
      userAgent: "TrucksupBuySellAudience",
      issuer: "TrucksupBuySellIssuer",
    });

    try {
      const response = await fetch(url, { method: "POST", headers, body });
      const data = await response.json();
      return data.accessToken;
    } catch (error) {
      console.error("Error generating JWT token:", error);
      return null;
    }
  }

  async function sendDataToClient(individualReport) {
    let token = sessionStorage.getItem("jwtToken");

    // If no token exists, generate a new token and store it
    if (!token) {
      console.log("No token found, generating a new one...");
      token = await generateJWTToken();

      if (token) {
        sessionStorage.setItem("jwtToken", token);
        console.log("Token stored successfully");
      } else {
        console.error("Token generation failed");
        return;
      }
    }

    let pdf = "";
    pdf = `https://instavaluer.com/commercialreportSinglePagerelease/${individualReport._id}`;
    // Send the data to the client API
    const url =
      "https://sslapi.trucksups.in/THAPIGateway/apiateway/InsertInspectionDetail";
    const headers = {
      "x-api-key": "IXebdb3P3qfMseQtgZxD7qxHdkUr3Ylq",
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const body = JSON.stringify({
      requestNo: individualReport.caseId,
      mobileNumber: individualReport.mobile,
      vehicleNumber: individualReport.regdNo,
      inspectionPdf: individualReport.reportUrl,
      requestedBy: individualReport.requesterName,
      requestId: individualReport.caseId,
      singleInspectionPdf: pdf
    });

    try {
      const response = await fetch(url, { method: "POST", headers, body });
      const data = await response.json();
      console.log("Data sent successfully:", data);
      alert("Data sent successfully");

      // After sending data, update pushDataTime
      const currentTime = new Date().toISOString(); // Get current time in ISO format
      const updateTimeUrl = `${Baseurl}/api/v1/cases/updatecase/${individualReport._id}`;
      const updateResponse = await axios.put(
        updateTimeUrl,
        { pushDataTime: currentTime },
        { headers: { "Content-Type": "application/json" } }
      );

      if (updateResponse.data.success) {
        console.log("PushDataTime updated successfully");
      } else {
        console.error("Failed to update PushDataTime");
      }
    } catch (error) {
      console.error("Error sending data to client:", error);
      alert("Error sending data to client:", error);
    }
  }

  const handleReport = (admin) => {
    const assetType = admin.assetType;
    if (
      assetType === "Four Wheeler" ||
      assetType === "Car Taxi" ||
      assetType === "Motor Cab" ||
      assetType === "Four Wheeler EV"
    ) {
      navigate(`/releasereport/${admin._id}`);
    } else if (assetType === "Two Wheeler" || assetType === "Two Wheeler EV") {
      navigate(`/twowheelerreportrelease/${admin._id}`);
    } else if (assetType === "Construction Equipment") {
      navigate(`/constructionreportrelease/${admin._id}`);
    } else if (assetType === "Commercial" || assetType === "Commercial EV") {
      navigate(`/commercialreportrelease/${admin._id}`);
    } else if (
      assetType === "Three Wheeler" ||
      assetType === "Three Wheeler EV"
    ) {
      navigate(`/threewheelerreportrelease/${admin._id}`);
    } else if (assetType === "Farm Equipment") {
      navigate(`/firmequipmentreportrelease/${admin._id}`);
    }
  };
  console.log(filterData, "filterData");
  
  const handleReport2 = (admin) => {
    navigate(`/commercialreportSinglePagerelease/${admin._id}`);
  }

  return (
    <>
      <div className="min-h-screen flex flex-col lg:ps-64 w-full">
        <div className="p-2 space-y-6">
          <div className="flex items-center justify-between w-full print:hidden">
            <h4 className="text-lg font-semibold text-default-900">
              Dashboard
            </h4>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <input
                type="text"
                placeholder="Enter vehicle no. "
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ border: "1px solid #dd5536", borderRadius: "10px" }}
              />
              <button
                onClick={() => handleSearch()}
                className="text-white px-4 py"
                style={{
                  padding: "10px 15px",
                  backgroundColor: "#e6632e",
                  borderRadius: "10px",
                }}
              >
                Search{" "}
              </button>
              <button
                onClick={() => handleReset()}
                className="text-white px-4 py"
                style={{
                  padding: "10px 15px",
                  backgroundColor: "#E20808",
                  borderRadius: "10px",
                }}
              >
                Reset{" "}
              </button>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1" style={{ marginBottom: "60px" }}>
          <div className="shadow rounded-lg bg-white dark:bg-default-50">
            <div className="border-t border-dashed border-default-200">
              <div
                className="relative overflow-x-auto"
                style={{ overflowY: "visible" }}
              >
                {filterData.length > 0 ? (
                  <InfiniteScroll
                    dataLength={filterData.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={<h4 className="text-center py-4">Loading...</h4>}
                    endMessage={
                      <p className="text-center py-4">
                        <b>No more reports to show</b>
                      </p>
                    }
                    scrollThreshold={0.9}
                  >
                    <table className="min-w-full table-fixed">
                      <thead className="bg-gray-100">
                        <tr>
                          <th style={{ width: "60px" }}>No</th>
                          <th style={{ width: "260px" }}>Name</th>
                          <th style={{ width: "260px" }}>Mobile</th>
                          <th style={{ width: "260px" }}>Date</th>
                          {/* <th style={{ width: '260px' }}>Email</th> */}
                          <th style={{ width: "260px" }}>State</th>
                          <th style={{ width: "260px" }}>Reg No.</th>
                          <th style={{ width: "260px" }}>Requested By</th>
                          <th style={{ width: "260px" }}>Payment Status</th>
                          <th style={{ width: "260px" }}>Payment Update</th>
                          <th style={{ width: "260px" }}>Edit Report</th>
                          <th style={{ width: "260px" }}>Generate Report</th>
                          {loginData?.role !== "businessAssociate" && (
                            <th style={{ width: "260px" }}>Alter</th>
                          )}
                          {
                            loginData?.role !== 'businessAssociate' &&
                            <th
                              style={{ width: "260px" }}>
                              Generate Single Page Report
                            </th>
                          }
                          <th style={{ width: "260px" }}>Update to Client</th>
                          {loginData?.role !== "businessAssociate" && (
                            <th style={{ width: "260px" }}>Delete</th>
                          )}
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-dashed divide-default-200">
                        {filterData.map((individualReport, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#f2f2f2" : "#fff",
                                margin:'10px 0px'
                            }}
                          >
                            <td className="text-center font-semibold">
                              {individualReport.caseId}
                            </td>
                            <td className="text-center font-semibold truncate">
                              {individualReport.name}
                            </td>
                            <td className="text-center">
                              {individualReport.mobile}
                            </td>
                            <td className="text-center truncate">
                              {moment(individualReport.createdAt)
                                .tz("Asia/Kolkata")
                                .format("YYYY-MM-DD HH:mm:ss")}
                            </td>
                            {/* <td className="text-center ">{individualReport.email}</td> */}
                            <td className="text-center truncate">
                              {individualReport.state}
                            </td>
                            <td className="text-center">
                              {individualReport.regdNo}
                            </td>
                            <td className="text-center truncate">
                              {individualReport.requesterName}
                            </td>
                            <td className="text-center">
                              <Switch
                                checked={individualReport?.paymentStatus}
                              />
                            </td>
                            <td className="text-center">
                              <button
                                className="p-2 rounded bg-cyan-500/20 text-cyan-500 hover:bg-cyan-500 hover:text-white"
                                onClick={() =>
                                  showPaymentModal(individualReport)
                                }
                              >
                                Update
                              </button>
                            </td>
                            <td className="text-center truncate">
                              <button
                                className="p-2 rounded bg-cyan-500/20 text-cyan-500 hover:bg-cyan-500 hover:text-white"
                                onClick={() =>
                                  handleUpdateReport(individualReport)
                                }
                              >
                                Edit Report
                              </button>
                            </td>
                            <td className="text-center truncate">
                              <button
                                className="p-2 rounded bg-cyan-500/20 text-cyan-500 hover:bg-cyan-500 hover:text-white"
                                onClick={() => handleReport(individualReport)}
                              >
                                Generate Report
                              </button>
                            </td>
                            {loginData?.role !== "businessAssociate" && (
                              <td className="text-center">
                                <button
                                  className="p-2 rounded bg-cyan-500/20 text-cyan-500 hover:bg-cyan-500 hover:text-white"
                                  onClick={() =>
                                    showDateModal(individualReport)
                                  }
                                >
                                  Alter
                                </button>
                              </td>
                            )}
                            <td className="whitespace-nowrap py-3 px-3 text-center text-sm font-medium"
                              style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#fff' }}
                            >
                              {(individualReport.assetType === 'Commercial' || individualReport.assetType === 'Commercial EV' 
                              ) ?
                                <button className="p-2 rounded bg-cyan-500/20 text-cyan-500 hover:bg-cyan-500 hover:text-white"
                                  onClick={() =>handleReport2(individualReport)}
                                >
                                  Generate Single Page Report
                                </button>: <></>}
                            </td>
                            <td className="whitespace-nowrap py-3 px-3 text-center text-sm font-medium"
                              style={{ backgroundColor: index % 2 === 0 ? '#f2f2f2' : '#fff' }}>
                              <div className="flex items-center justify-center gap-2">
                              {(individualReport?.requesterBranch ===
                                "TRUCKSUP SOLUTIONS PVT. LTD" || individualReport?.requesterBranch.trim() == "Trucksup Solutions Pvt. Ltd.") &&
                              (individualReport?.requesterName ===
                                "TRUCKSUP SOLUTIONS PVT. LTD" || individualReport?.requesterName.trim() === "Trucksup Solution Private Limited.") ? (
                                individualReport?.pushDataTime === null ? (
                                  <button
                                    className="p-2 rounded bg-cyan-500/20 text-cyan-500 hover:bg-cyan-500 hover:text-white"
                                    onClick={async () => {
                                      try {
                                        await sendDataToClient(
                                          individualReport
                                        );
                                      } catch (error) {
                                        console.error(
                                          "Error sending data to client:",
                                          error
                                        );
                                      }
                                    }}
                                  >
                                    Send Data to Client
                                  </button>
                                ) : (
                                  <button
                                    style={{ backgroundColor: 'green', color: 'white', borderRadius: '0.25rem', padding: '0.5rem' }}
                                    onClick={async () => {
                                      try {
                                        await sendDataToClient(
                                          individualReport
                                        );
                                      } catch (error) {
                                        console.error(
                                          "Error sending data to client:",
                                          error
                                        );
                                      }
                                    }}
                                  >
                                    Sent on{" "}
                                    {moment(individualReport.pushDataTime)
                                      .tz("Asia/Kolkata")
                                      .format("YYYY-MM-DD HH:mm:ss")}
                                  </button>
                                )
                              ): null}
                              </div>
                            </td>
                            {loginData?.role !== "businessAssociate" && (
                              <td className="text-center">
                                <button
                                  className="p-2 rounded bg-cyan-500/20 text-cyan-500 hover:bg-cyan-500 hover:text-white"
                                  onClick={() => showModal(individualReport)}
                                >
                                  Delete
                                </button>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </InfiniteScroll>
                ) : (
                  <div style={{ height: "400px" }}>
                    <div
                      style={{
                        height: "300px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src="/assets/Adsum Advisory Services Pvt. Ltd._files/emptyBox.jpg"
                        alt="empty_image"
                        height="180px"
                        width="200px"
                      />
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "700",
                        color: "#000",
                      }}
                    >
                      Currently don't have any completed case !!!{" "}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-6 py-3 px-6 border-t border-dashed border-default-200"></div>
          </div>
        </div>

        {/* Modals remain the same as before */}
        {/* Modals remain the same as before */}
        <Modal
          title="Delete Case"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button
              style={{
                padding: "10px 15px",
                color: "#fff",
                backgroundColor: "#FF0000",
              }}
              onClick={() => handleCancel()}
            >
              Cancel
            </Button>,
            <Button
              style={{
                padding: "10px 15px",
                color: "#fff",
                backgroundColor: "#04681e",
              }}
              onClick={(e) => updateClick(e)}
            >
              Confirm
            </Button>,
          ]}
        >
          <p>
            Are you sure you want to delete case of {selectedCase.requesterName}
          </p>
        </Modal>

        <Modal
          title="AlterDate"
          open={isDateModalOpen}
          onOk={handleDateOk}
          onCancel={handleDateCancel}
          footer={[
            <Button
              style={{
                padding: "10px 15px",
                color: "#fff",
                backgroundColor: "#FF0000",
              }}
              onClick={() => handleDateCancel()}
            >
              Cancel
            </Button>,
            <Button
              style={{
                padding: "10px 15px",
                color: "#fff",
                backgroundColor: "#04681e",
              }}
              onClick={(e) => updateDateClick(e)}
            >
              Confirm
            </Button>,
          ]}
        >
          <div>
            Creation Date:
            <input type="date" onChange={(e) => onChange(e)} />
          </div>
          <div style={{ marginTop: "10px" }}>
            Update Date:
            <input
              style={{ marginLeft: "8px" }}
              type="date"
              onChange={(e) => onUpdateChange(e)}
            />
          </div>
        </Modal>

        <Modal
          title="Payment Status"
          open={paymentModalOpen}
          onOk={handlePaymentCancel}
          onCancel={handlePaymentCancel}
          footer={[
            <Button
              style={{
                padding: "10px 15px",
                color: "#fff",
                backgroundColor: "#FF0000",
              }}
              onClick={() => handlePaymentCancel()}
            >
              Cancel
            </Button>,
            <Button
              style={{
                padding: "10px 15px",
                color: "#fff",
                backgroundColor: "#04681e",
              }}
              onClick={(e) => handleUpdatePayment(e)}
            >
              Confirm
            </Button>,
          ]}
        >
          <div>
            Payment Status :
            <Switch
              style={{ marginLeft: "8px" }}
              checked={statusOfPayment ? true : false}
              onChange={() => handlePaymentStatus()}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            Payment Remark:
            <input
              style={{ marginLeft: "8px", borderRadius: "10px" }}
              type="text"
              value={remarkOfPayment}
              onChange={(e) => setRemarkOfPayment(e.target.value)}
            />
          </div>
        </Modal>
        {/* ... */}
      </div>
    </>
  );
};

export default ReadyReport;
